import { Injectable } from '@angular/core';
import { of, tap } from 'rxjs';
import { RequestService } from 'src/app/core/service/request.service';
import { environment } from 'src/environments/environment';


@Injectable({
  providedIn: 'root'  // 讓 service 變成 singleton
})
export class MenuService {
  private menuItems: any[] | null = null;
  constructor(
    private requestService: RequestService
  ) { }

  GetMenu(value: string){
    // 如果已經取過，就直接回傳記憶體內容
    if (this.menuItems) {
      return of(this.menuItems);
    }
    var param = {
      "CompanyID": value
    };
    // 第一次才呼叫 API，並記錄結果
    return this.requestService.Post<any>(environment.baseUrl + '/Liff/GetMenu',param).pipe(
      tap((items:any) => this.menuItems = items.LineInfo)
    );
  }

  GetCompany(CompanyID: string){
      const url = environment.baseUrl + '/Liff/GetCompany';
      let param = { CompanyID: CompanyID };
      return this.requestService.Post<any>(url, param);
  }
}
